import { render } from "./BaseFeedHeader.vue?vue&type=template&id=5495a770&scoped=true"
import script from "./BaseFeedHeader.vue?vue&type=script&lang=ts"
export * from "./BaseFeedHeader.vue?vue&type=script&lang=ts"

import "./BaseFeedHeader.vue?vue&type=style&index=0&id=5495a770&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5495a770"

export default script